// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cvat-page-toolbar {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0.75rem 1rem;
}

.cvat-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cvat-page .datasets {
  width: 100%;
  max-width: 100%;
  margin: 0;
}

.cvat-page .cvat-projects-customized-content,
.cvat-page .cvat-upload-input,
.cvat-page .cvat-select,
.cvat-page .cvat-project-info,
.cvat-page .button-container {
  width: 100%;
  min-width: 0;
  align-self: stretch;
  box-sizing: border-box;
}

.cvat-toolbar-hint {
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.cvat-upload-input {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.cvat-select {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.cvat-select label {
  display: block;
  margin: 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cvat-select-option {
  width: 100%;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
}

.cvat-select-option:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  outline: none;
}

.cvat-select-option-container {
  width: 100%;
  overflow: hidden;
}

.cvat-page .dataset-card .cvat-organization-select-option-container,
.cvat-page .dataset-card .cvat-project-select-option-container,
.cvat-page .dataset-card .label-field-select-option-container {
  width: 100%;
  height: var(--dataset-card-control-height);
  flex: 0 0 var(--dataset-card-control-height);
}

.cvat-page .dataset-card .cvat-select-option {
  width: 100%;
  height: var(--dataset-card-control-height);
  min-height: var(--dataset-card-control-height);
  max-height: var(--dataset-card-control-height);
  margin: 0;
  padding: 0 36px 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.2;
  box-sizing: border-box;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin: 0;
}

.annotate-selected-container {
  width: 100%;
  margin: 0;
}

.cvat-projects-customized-content,
.cvat-project-info,
.otherbackend-message {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.cvat-project-info a,
.otherbackend-message a {
  color: #2563eb !important;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none !important;
}

.cvat-project-info .card-text,
.otherbackend-message .card-text {
  margin: 0;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.cvat-upload-input .org-btn,
.cvat-project-info .org-btn,
.annotate-selected-container .org-btn,
.cvat-page .dataset-toolbar .org-btn {
  min-height: 38px;
  font-size: 13px;
}

.cvat-project-info .org-btn,
.cvat-upload-input .org-btn {
  width: 100%;
  max-width: none;
}

.annotate-selected-container .input-group {
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
}

.annotate-selected-container h6 {
  margin: 0 !important;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CVATPage/CVATPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,8CAA8C;EAC9C,8CAA8C;EAC9C,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".cvat-page-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 0.75rem 1rem;\n}\n\n.cvat-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cvat-page .datasets {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n}\n\n.cvat-page .cvat-projects-customized-content,\n.cvat-page .cvat-upload-input,\n.cvat-page .cvat-select,\n.cvat-page .cvat-project-info,\n.cvat-page .button-container {\n  width: 100%;\n  min-width: 0;\n  align-self: stretch;\n  box-sizing: border-box;\n}\n\n.cvat-toolbar-hint {\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.cvat-upload-input {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.cvat-select {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.cvat-select label {\n  display: block;\n  margin: 0;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cvat-select-option {\n  width: 100%;\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.cvat-select-option:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n  outline: none;\n}\n\n.cvat-select-option-container {\n  width: 100%;\n  overflow: hidden;\n}\n\n.cvat-page .dataset-card .cvat-organization-select-option-container,\n.cvat-page .dataset-card .cvat-project-select-option-container,\n.cvat-page .dataset-card .label-field-select-option-container {\n  width: 100%;\n  height: var(--dataset-card-control-height);\n  flex: 0 0 var(--dataset-card-control-height);\n}\n\n.cvat-page .dataset-card .cvat-select-option {\n  width: 100%;\n  height: var(--dataset-card-control-height);\n  min-height: var(--dataset-card-control-height);\n  max-height: var(--dataset-card-control-height);\n  margin: 0;\n  padding: 0 36px 0 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  color: #0f172a;\n  font-size: 13px;\n  line-height: 1.2;\n  box-sizing: border-box;\n}\n\n.button-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  margin: 0;\n}\n\n.annotate-selected-container {\n  width: 100%;\n  margin: 0;\n}\n\n.cvat-projects-customized-content,\n.cvat-project-info,\n.otherbackend-message {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.cvat-project-info a,\n.otherbackend-message a {\n  color: #2563eb !important;\n  font-size: 13px;\n  font-weight: 800;\n  text-decoration: none !important;\n}\n\n.cvat-project-info .card-text,\n.otherbackend-message .card-text {\n  margin: 0;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.cvat-upload-input .org-btn,\n.cvat-project-info .org-btn,\n.annotate-selected-container .org-btn,\n.cvat-page .dataset-toolbar .org-btn {\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.cvat-project-info .org-btn,\n.cvat-upload-input .org-btn {\n  width: 100%;\n  max-width: none;\n}\n\n.annotate-selected-container .input-group {\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #ffffff;\n}\n\n.annotate-selected-container h6 {\n  margin: 0 !important;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
